export enum BrokerageStateEnum {
  StatusUnknown = 1,
  Active = 2,
  Terminated = 3,
  TradeAgreed = 4
}
